module.exports = __webpack_public_path__ + "static/img/meishi2.013bb15e.jpg";